import { useState } from "react";
import PageTemplate from "../components/PageTemplate";
import PhotoAlbum from "react-photo-album";
import "react-photo-album/rows.css";
import "react-photo-album/masonry.css";
import "react-photo-album/columns.css";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { Fullscreen, Slideshow, Download } from "yet-another-react-lightbox/plugins";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import Container from "../components/Container";
import Content from "../components/Content";
import vietnamPhotos from '../vietnamPhotos.json';
import vietnamThumbnailsPhotos from '../vietnamThumbnailsPhotos.json';
import { Link } from 'react-router-dom';
import PageFade from "../motions/PageFade";
import { useEffect } from 'react';

function VietnamPhotos() {
    console.log("VietnamPhotos rendered");

    useEffect(() => {
        console.log("VietnamPhotos mounted");

        return () => {
            console.log("VietnamPhotos unmounted");
        };
    }, []);

    const [index, setIndex] = useState(-1);

    return (
        <PageFade>
            <PageTemplate minor={true} title="Pre-Wedding Photos in Vietnam" textColor="text-rose">
                <Content>
                    <div>
                        <p className="mb-10">
                            To celebrate Thuyan's heritage, we had a pre-wedding shoot on a warm, sunny day in Da Nang, Vietnam.
                        </p>
                        <p>
                            <Link to="/gallery" className="text-rose hover:underline">
                                Back to Wedding Gallery
                            </Link>
                        </p>
                    </div>
                </Content>
                <Container>
                    <div className="mx-auto">
                        <PhotoAlbum
                            photos={vietnamThumbnailsPhotos}
                            layout="rows"
                            onClick={({ index }) => setIndex(index)}
                        />

                        <Lightbox
                            slideshow={{ delay: 5000 }}
                            slides={vietnamPhotos}
                            open={index >= 0}
                            index={index}
                            close={() => setIndex(-1)}
                            plugins={[Fullscreen, Slideshow, Download]}
                            styles={{
                                container: {
                                    backgroundColor: "rgba(0, 0, 0, 0.9)"
                                },
                            }}
                        />
                    </div>
                    <p className="mt-10">
                        <Link to="/gallery" className="text-rose hover:underline">
                            Back to Wedding Gallery
                        </Link>
                    </p>
                </Container>
            </PageTemplate>
        </PageFade>
    );
}

export default VietnamPhotos;
